import { Params } from '@angular/router';
import { IgMedia } from '@core/models/ApiFields/ig-entities';
import { IData, ReqMode } from '@core/models/IApi';
import { fixdFields } from '@features/social-analysis/social-listening/config/api-params';
import { COMPONENTS_ENUM } from '@features/social-analysis/social-listening/config/page';
import { PageFiltersState } from '@features/social-analysis/social-shared/store/page-filters.store';
import { TableState } from '@features/social-analysis/social-shared/store/table.store';
import { TableHttpBuilder } from '../../social-shared/services/http/table-simple-http';

export class PostsHttpBuilder extends TableHttpBuilder {
    protected buildParams(
        { limit, offset, sorting, hiddenSort }: TableState<IData>,
        pageFilters: PageFiltersState,
        mode: ReqMode
    ): Params {
        const dates = this.getDates(pageFilters.selectedDates());
        return {
            ...dates,
            fields: this.getFields(),
            limit: limit(),
            offset: offset(),
            sort: this.formatSorting(sorting(), hiddenSort),
            mode: mode,
            ...this.getMediaTypeFilter(),
            ...this.formatFilters(pageFilters.appliedFilters()),
        };
    }

    protected getFields(): string {
        return fixdFields[COMPONENTS_ENUM.POSTS].join();
    }

    private getMediaTypeFilter() {
        return { [IgMedia.getPrefixed('mediaType')]: 'neq:tag' };
    }
}
